module.exports = __webpack_public_path__ + "3ff0e6de65d99be558429e626e7fc729.MP3";